import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import Topbar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import { Form, Modal, Dropdown } from "react-bootstrap";
import ModalLoader from "../ModalLoader";
import { toast } from "react-toastify";
import { URLS } from "../urls";
import {
  arrangeEventObject,
  fetchActionsUtil,
  statusColor,
  stringifyQueryString,
  useCookie,
} from "../../utils";
import moment from "moment";
import TableComponent from "../TableComponent";
import DisplaySingleModal from "./DisplaySingleModal";
import AddAttendanceModal from "./AddAttendance";
import { CachedIcon, DownloadIcon, ExcelIcon, ExportIcon } from "../icons";
import "./attendance.css";
import { Add, CalendarTodayOutlined } from "@mui/icons-material";
import NoTableItem from "../NoTableItem";
import { UseQueryData } from "../UseQueryData";
import CustomPagination from "../Paginations";
import RsDateRangePicker from "../RsDateRangePicker";
import { EditAttendance } from "./EditAttendance";
import { useDownloadExcel } from "../useDownloadExcel";
import { CSVLink } from "react-csv";

const chooseStatus = [
  "No SignOut",
  "Early Closure",
  "Late",
  "Absent",
  "Good",
  "OnLeave",
  "Permitted",
  "Not a staff",
  "Weekend",
];

function NewTimeSheet() {
  // ------------------ Filter Search -------------------//
  const initialQueryParams = {
    limit: 20,
    page: 1,
    id: "",
    name: "",
    startDate: "",
    endDate: "",
  };
  const { queryParams, theQueryParams, onChangeInput, setQueryParams } =
    UseQueryData({
      initialQueryParams,
      timer: 1500,
    });
  // ------------------ Filter Search -------------------//

  const [returnParams, setReturnParams] = useState({
    count: 0,
    endIndex: 0,
    startIndex: 0,
  });

  const branch_id = useCookie("branch_id");
  const [loading, setLoading] = useState(false);
  const [UsersID, setUsersID] = useState("");
  const [showSaveButton, setshowSaveButton] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showDisplaySingle, setShowDisplaySingle] = useState(false);
  const [timeSheetToDelete, setTimeSheetToDelete] = useState();
  const [showAttendance, setShowAttendence] = useState([]);

  const [status, setStatus] = useState("");
  const [groupedAttendance, setGroupedAttendance] = useState([]);

  const [editDetails, setEditDetails] = useState({
    open: false,
    employeeName: "",
    employeeID: "",
    date: "",
  });

  const [excelData, setExcelData] = useState([]);

  const CSVLinkRef = useRef(null);

  // fetch excel hook
  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );

  const getAttendance = useCallback(async () => {
    try {
      setLoading(true);

      const result = await fetchActionsUtil(
        `${URLS.backendattendance}/get/${branch_id}?${stringifyQueryString(
          queryParams
        )}`
      );

      setShowAttendence(result?.attendance);

      setReturnParams({
        count: result?.count,
        endIndex: result?.endIndex,
        startIndex: result?.startIndex,
      });
    } catch (error) {
      console.log(error);

      toast("Unable to get TimeSheet", {
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [branch_id, queryParams]);

  const getAttendanceProcessStatus = useCallback(async () => {
    const result = await fetchActionsUtil(
      `${URLS.backendattendance}/attendance-status-check?branch_id=${branch_id}`
    );
    if (result?.success) {
      setStatus(result?.data?.status || "");
    } else {
      setStatus("Failed");
    }
  }, [branch_id]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getAttendance();
      getAttendanceProcessStatus();
    }

    return () => {
      isMounted = false;
    };
  }, [getAttendance, getAttendanceProcessStatus]);

  const SaveAttendance = async () => {
    setLoading(true);
    const token = "dummy token";

    try {
      for (let index = 0; index < groupedAttendance.length; index++) {
        const attendances = groupedAttendance[index];

        const { excellDetails } = attendances;

        // Split excellDetails into chunks of 500 and upload each chunk sequentially
        if (Array.isArray(excellDetails) && excellDetails.length > 0) {
          const chunkSize = 500;
          for (let i = 0; i < excellDetails.length; i += chunkSize) {
            const chunk = excellDetails.slice(i, i + chunkSize);
            const payload = {
              ...attendances,
              excellDetails: chunk,
            };
            await fetchActionsUtil(
              `${URLS.backendattendance}/add`,
              "POST",
              token,
              { showAttendance: payload }
            );
          }
        }
      }
      toast("Save Successfully", {
        type: "success",
      });
    } catch (err) {
      toast("Unable to get TimeSheet", {
        type: "error",
      });
      console.log({ err });
    } finally {
      setLoading(false);
      setshowSaveButton(false);
    }
  };

  const deleteTimeSheet = (data) => {
    setTimeSheetToDelete();
    setLoading(true);
    const token = "dummy token";
    fetch(`${URLS.backendPayroll}/delete-time-sheet`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          toast("Deleted successfully", {
            type: "success",
          });
          getAttendance();
        } else {
          throw Error();
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        toast("Unable to delete", {
          type: "error",
        });
      });
  };

  const onRowClick = (attendance) => {
    setUsersID(attendance.ID);
    setShowDisplaySingle(true);
  };

  const tableHead = () => {
    return (
      <thead className="table">
        <tr>
          <th></th>
          <th>No</th>
          <th>Employee Name </th>
          <th>Employee ID </th>
          <th>Date </th>
          <th>In-Time</th>
          <th>Out-Time</th>
          <th>Result</th>
          <th>Source</th>
        </tr>
      </thead>
    );
  };

  const tableBodyData = (attendance, index) => {
    return (
      <>
        <td className="text-right">
          {!showSaveButton ? (
            <Dropdown>
              <Dropdown.Toggle variant="" bsPrefix="">
                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu
                popperConfig={{
                  strategy: "fixed",
                }}
                renderOnMount
                className="text-center"
              >
                <Dropdown.Item
                  as="div"
                  className="p-cursor"
                  onClick={() =>
                    setEditDetails((prev) => ({
                      employeeName: attendance.Name,
                      open: true,
                      employeeID: attendance.ID,
                      date: attendance?.Date,
                    }))
                  }
                >
                  <i className="fa fa-pencil m-r-5"></i> Edit
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : null}
        </td>
        <td>{index + returnParams.startIndex + 1}</td>
        <td>{attendance.Name}</td>
        <td>{attendance.ID}</td>
        <td className="d-flex gap-3 align-items-center">
          {" "}
          <span>
            {" "}
            <CalendarTodayOutlined fontSize="small" />{" "}
          </span>{" "}
          <p>{moment(attendance?.Date)?.format("MMMM Do YYYY")}</p>{" "}
        </td>
        <td>{attendance.in}</td>
        <td>{attendance.out}</td>
        <td>
          <p
            className={`tw-status ${statusColor(
              ["No SignOut", "Early Closure", "Late", "Absent"].includes(
                attendance.result
              )
                ? "red"
                : attendance.result === "Good"
                ? "green"
                : attendance.result === "OnLeave"
                ? "orange"
                : "blue"
            )}`}
          >
            {attendance.result}
          </p>
        </td>
        <td>{attendance?.uploadType}</td>
      </>
    );
  };

  const dropDownFunction = (qty) => {
    setQueryParams((el) => ({ ...el, limit: qty }));
  };

  const filterByDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: picker.startDate,
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: picker.endDate,
      })
    );

    picker.element.val(
      picker.startDate.format("DD-MM-yyyy") +
        " - " +
        picker.endDate.format("DD-MM-yyyy")
    );
  };

  const clearDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: "",
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: "",
      })
    );

    picker.element.val("");
  };

  const onDownloadExcelData = async () => {
    let exData = showAttendance?.map((attendance, index) => [
      index + returnParams.startIndex + 1,
      attendance.Name,
      attendance.ID,
      moment(attendance?.Date)?.format("MM/DD/YYYY"),
      attendance.in,
      attendance.out,
      attendance.result,
      attendance?.uploadType,
    ]);

    const normalHead = [
      "No",
      "Name",
      "ID",
      "Date",
      "In-Time",
      "Out-Time",
      "Result",
      "Origination",
    ];

    const date = `Date Prepared: ${moment(new Date()).format(
      "MMMM DD yyyy k:mm:ss z"
    )}`;

    exData = [
      // [company],
      ["User Report"],
      [date],
      [""],
      normalHead,
      ...exData,
      [""],
    ];

    // console.log(exData);
    setExcelData(exData);
  };

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <Topbar />
        <Sidebar />
        <section className="bg-white page-header position-relative w-100 page-header-2">
          <div className="page-wrapper">
            <div className="d-flex w-100  m-0 p-0 align-items-center justify-content-between gap-5">
              <div className="">
                <h4 className="page-title page-title-alt">Attendance</h4>
                <div className="d-flex align-items-baseline">
                  <p className="page-paragraph">All employees attendance</p>
                  <div>
                    <button
                      title="Reload"
                      onClick={() => {
                        getAttendance();
                      }}
                      className="btn text-primary"
                    >
                      <CachedIcon />
                    </button>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-baseline">
                {["Success", ""].includes(status) ? null : (
                  <div className="d-flex align-items-baseline">
                    <div>
                      <p
                        className={`tw-status text-center ${statusColor(
                          ["Started", "Pending"].includes(status)
                            ? "orange"
                            : status === "Success"
                            ? "green"
                            : status === "Failed"
                            ? "red"
                            : ""
                        )}`}
                      >
                        {status === "Pending"
                          ? "Attendance sync is running. Please wait."
                          : status === "Failed"
                          ? "Attendance sync failed. Please contact admin."
                          : ""}
                      </p>
                    </div>

                    <div>
                      <button
                        title="Check sync status"
                        onClick={() => {
                          getAttendance();
                          getAttendanceProcessStatus();
                        }}
                        className="btn text-primary"
                      >
                        <CachedIcon />
                      </button>
                    </div>
                  </div>
                )}
                <div className="mx-3">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant=""
                      className="btn secondary"
                      bsPrefix=""
                    >
                      Template <DownloadIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      popperConfig={{
                        strategy: "fixed",
                      }}
                      renderOnMount
                      className="text-center"
                    >
                      <Dropdown.Item as="div">
                        <a
                          href={`/excel_templates/Attendance_Sample.csv`}
                          target="blank"
                          title="Download"
                          download=""
                        >
                          Template to import attendance
                        </a>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <div>
                  <CSVLink
                    className="btn print d-none"
                    filename={`Attendance Report(${moment(new Date()).format(
                      "DD-MMM-yyyy hh:mm:ss a"
                    )}).csv`}
                    data={excelData}
                    ref={CSVLinkRef}
                  />

                  <Dropdown className="mx-3">
                    <Dropdown.Toggle
                      variant=""
                      className="print"
                      disabled={isfetchingExcel}
                      bsPrefix=""
                    >
                      <span className="mx-2 text-12">Export</span>
                      <ExportIcon fontSize="12px" color="#008000" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      popperConfig={{
                        strategy: "fixed",
                      }}
                      renderOnMount
                      className="text-center"
                    >
                      <Dropdown.Item
                        as="div"
                        onClick={onDownloadExcelData}
                        className="p-cursor"
                      >
                        Excel <ExcelIcon color="#008000" />
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <button
                  className="btn add-btn"
                  onClick={() => setShowUploadModal(true)}
                >
                  <Add />
                  Upload Attendance
                </button>
              </div>
            </div>
          </div>
        </section>
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper  mt-n10">
          {/*<!-- Page Content -->*/}
          <div className="content container-fluid">
            {/*<!-- Page Title -->*/}

            {/*<!-- /Page Title -->*/}
            {/*<!-- Content Starts -->*/}

            <div className="p-3">
              <div className="">
                <div className="normal-grid">
                  <div className="">
                    <Form.Group className="">
                      <Form.Control
                        name="id"
                        type="text"
                        placeholder="Employee ID"
                        value={theQueryParams.id}
                        onChange={onChangeInput}
                      />
                    </Form.Group>
                  </div>
                  <div className="">
                    <Form.Group className="">
                      <Form.Control
                        name="name"
                        placeholder="Employee name"
                        type="text"
                        value={theQueryParams.name}
                        onChange={onChangeInput}
                      />
                    </Form.Group>
                  </div>

                  <div>
                    <select
                      className="form-control"
                      onChange={onChangeInput}
                      name="status"
                      value={theQueryParams.status}
                    >
                      <option selected value="">
                        Select status
                      </option>
                      {chooseStatus?.map((el) => (
                        <option value={el}>{el}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <RsDateRangePicker
                      placement="topEnd"
                      className="form-control-w-0 w-100"
                      onClean={(event, picker) => clearDateRange(event, picker)}
                      onOk={(event, picker) => filterByDateRange(event, picker)}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                {showAttendance?.length > 0 && showSaveButton && (
                  <button onClick={SaveAttendance} className="btn btn-primary">
                    Save Attendance
                  </button>
                )}
              </div>

              <div className="mt-4">
                {/*<!-- JobGradeHistory Table -->*/}
                <div className="info">
                  <div className="table-height">
                    {showAttendance?.length > 0 ? (
                      <TableComponent
                        responsive
                        borderless
                        // striped
                        sticky
                        // hover
                        tableHeadsFunction={tableHead}
                        mainDataArray={showAttendance}
                        tableDataRowFunction={tableBodyData}
                        className="product-table text-nowrap"
                        onDoubleClickRow={onRowClick}
                      />
                    ) : (
                      <NoTableItem />
                    )}
                  </div>
                </div>
                {/*<!-- Table --> */}
              </div>
            </div>

            {/*<!-- /Content End -->*/}

            {!showSaveButton ? (
              <div className="my-4">
                <CustomPagination
                  setQueryParams={setQueryParams}
                  startIndex={returnParams.startIndex}
                  endIndex={returnParams.endIndex}
                  count={returnParams.count}
                  limit={queryParams.limit}
                  page={queryParams.page}
                  dropDownFunction={dropDownFunction}
                />
              </div>
            ) : null}
          </div>
          {/*<!-- /Page Content -->*/}
        </div>
        {/*<!-- /Page Wrapper -->*/}
      </div>
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <div className="sidebar-overlay" data-reff=""></div>
      <ModalLoader show={loading} />
      {showUploadModal && (
        <AddAttendanceModal
          setShowUploadModal={setShowUploadModal}
          showAttendance={setShowAttendence}
          setshowSaveButton={setshowSaveButton}
          getAttendanceProcessStatus={getAttendanceProcessStatus}
          setGroupedAttendance={setGroupedAttendance}
        />
      )}
      {timeSheetToDelete && (
        <DeleteTimeSheetModal
          setTimeSheetToDelete={setTimeSheetToDelete}
          deleteTimeSheet={deleteTimeSheet}
          timeSheetToDelete={timeSheetToDelete}
        />
      )}
      {showDisplaySingle && (
        <DisplaySingleModal
          setShowDisplaySingle={setShowDisplaySingle}
          UserId={UsersID}
          noneSaveEntries={showAttendance}
          showSaveButton={showSaveButton}
          startDate={queryParams?.startDate}
          endDate={queryParams?.endDate}
        />
      )}
      {editDetails.open ? (
        <EditAttendance
          show={editDetails.open}
          handleClose={() =>
            setEditDetails((prev) => ({ ...prev, open: false }))
          }
          details={editDetails}
          reload={getAttendance}
        />
      ) : null}
    </body>
  );
}

function DeleteTimeSheetModal({
  timeSheetToDelete,
  setTimeSheetToDelete,
  deleteTimeSheet,
}) {
  return (
    <Modal
      centered
      show={true}
      onHide={() => {
        setTimeSheetToDelete();
      }}
      className="custom-modal"
    >
      <Modal.Body>
        <div className="form-header">
          <h3>Delete Allowance</h3>
          <p>Are you sure want to delete?</p>
        </div>
        <div className="modal-btn delete-action p-cursor">
          <div className="row">
            <div className="col-6">
              <div
                className="btn  continue-btn btn-danger "
                onClick={() => deleteTimeSheet(timeSheetToDelete)}
              >
                Delete
              </div>
            </div>
            <div className="col-6">
              <div
                data-dismiss="modal"
                className="btn btn-primary cancel-btn"
                onClick={() => {
                  setTimeSheetToDelete();
                }}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    User: state.api.User,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NewTimeSheet));
